export default __webpack_public_path__ + "static/media/midasi_point_ja_pc@2x.d3c9046f.png";